import React, { useState } from 'react';
import { Popover } from 'antd';
import IconBtn from '../../../../../../shared/ui/IconBtn/IconBtn';
import { shutdownAttachments } from '../../../../../../shared/api/queries';
import PopoverContent from '../PopoverContent/PopoverContent';
import styles from './ShutdownAttachments.module.scss';

const { useShutdownAttachments } = shutdownAttachments;

const ShutdownAttachments = ({ shutdown }) => {
  const [visible, setVisible] = useState(false);

  const { data, isFetching } = useShutdownAttachments(shutdown.alertId, {
    staleTime: 1000 * 60,
    enabled: visible,
  });

  const isEmpty = !data || data.length === 0;

  return (
    <Popover
      overlayClassName={styles.root}
      visible={visible}
      onVisibleChange={(visible) => setVisible(visible)}
      trigger="click"
      placement="right"
      content={
        <PopoverContent
          attachments={data}
          loading={isFetching}
          shutdownId={shutdown.alertId}
          key={isFetching}
        />
      }
    >
      <IconBtn
        tooltipTitle="Вложения"
        icon="paper-clip"
        style={{ color: isEmpty ? '#a7a7a7' : '' }}
      />
    </Popover>
  );
};

export default ShutdownAttachments;
